import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> KAZI SHAHRIAR SANJID</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <p>PhD Applicant | Algorithms, AI & Systems for Computational Biology</p>
                <p>Contact: +8801339870730 | Email: ratimshariar@gmail.com</p>
                <p>Location: Dhaka, Bangladesh</p>
                <p>
                  <a href="https://www.linkedin.com/in/kazi-shahriar-sanjid-302a031a5/" target="_blank" rel="noopener noreferrer" style={{ color: "white", marginRight: "10px" }}>LinkedIn</a> | 
                  <a href="https://github.com/Ratim321" target="_blank" rel="noopener noreferrer" style={{ color: "white", marginLeft: "10px", marginRight: "10px" }}>GitHub</a> | 
                  <a href="https://scholar.google.com/citations?user=nP85SgUAAAAJ&hl=en" target="_blank" rel="noopener noreferrer" style={{ color: "white", marginLeft: "10px" }}>Google Scholar</a>
                </p>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
